import { createReducer } from '@reduxjs/toolkit'

import { insertItems } from 'redux/utils'

import { TagOptionReducerType } from 'types/GlobalTagOptions'

import * as actions from '../../actions/TagOptions/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

// Initial state
const INITIAL_STATE: TagOptionReducerType = {
  data: {},
  fetched: false
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload.data)
      state.fetched = true
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
